export const plData = `
  <div class="paragraph">
    <div class="page-title">Najczęściej zadawane pytania dotyczące programu Trade-In (FAQ)</div>
  </div>
  <div class="paragraph">
    <div class="title">Kto może dołączyć do programu Trade-In?</div>
    <div class="text-box">
      <div class="text">
        Usługa Trade-In jest dostępna dla osób, które ukończyły 18 lat i legalnie zamieszkują na terytorium państwa członkowskiego Unii Europejskiej lub w Zjednoczonym Królestwie.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Co powinienem zrobić przed wysłaniem swojego starego urządzenia?</div>
    <div class="text-box">
      <div class="text">
        Przed wysłaniem urządzenia:<br>
        • Usuń wszystkie dane osobowe oraz wszelkie kody PIN, hasła lub blokady ekranu.<br>
        • Wykonaj pełne przywrócenie ustawień fabrycznych.<br>
        • Na iPhonie: wyloguj się z konta iCloud, wyłączając funkcję "Znajdź mój iPhone".<br>
        • Na Androidzie: usuń konto Google (Ustawienia > Konta > Google > Usuń konto).<br>
        Dzięki temu urządzenie nie będzie już powiązane z Twoim kontem, a Twoje dane osobowe pozostaną chronione.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Jak mogę wysłać swoje stare urządzenie?</div>
    <div class="text-box">
      <div class="text">
        <strong>Opakowanie:</strong> użyj solidnego, nieprzezroczystego pudełka (nieprzezroczystego) i dodaj wewnętrzne zabezpieczenie (np. folię bąbelkową), aby zapobiec uszkodzeniom podczas transportu.<br>
        <strong>Etykieta wysyłkowa:</strong> jeśli nie masz odpowiednich materiałów do pakowania, możesz je otrzymać w punkcie nadania przy dostarczaniu paczki.<br>
        <strong>Dokumentacja:</strong> wydrukuj, wypełnij i podpisz Deklarację uczciwości, a następnie umieść ją w paczce przed zamknięciem.<br>
        <strong>Bezpieczne zamknięcie:</strong> upewnij się, że paczka jest dobrze zamknięta i przymocuj bezpłatną etykietę wysyłkową w widocznym miejscu.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Jakie urządzenia nie są akceptowane?</div>
    <div class="text-box">
      <div class="text">
        Nie przyjmujemy urządzeń, które:<br>
        • są zablokowane przez operatora (SIM-lock);<br>
        • nie włączają się ani nie ładują;<br>
        • nie mogą połączyć się przez Bluetooth lub Wi-Fi;<br>
        • mają usterkę wewnętrzną lub uszkodzoną płytę główną;<br>
        • są nadal powiązane z kontem iCloud lub Google;<br>
        • są podróbkami lub replikami;<br>
        • są poważnie uszkodzone.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Czy muszę wysłać akcesoria (ładowarkę, kabel itp.)?</div>
    <div class="text-box">
      <div class="text">
        Nie jest to obowiązkowe, ale zalecane. Dołączenie akcesoriów wspiera zrównoważony rozwój i umożliwia ponowne wykorzystanie urządzeń.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Czy muszę wysłać słuchawki?</div>
    <div class="text-box">
      <div class="text">
        Nie. Ze względów higienicznych słuchawki zostaną zutylizowane i nie będą brane pod uwagę w ocenie.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Czy muszę wysłać fakturę zakupu?</div>
    <div class="text-box">
      <div class="text">
        Nie, nie jest wymagana do oceny ani do dokonania płatności. Możesz zachować ją dla własnej dokumentacji.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Jak oceniane jest moje stare urządzenie?</div>
    <div class="text-box">
      <div class="text">
        Korzystamy z certyfikowanego oprogramowania diagnostycznego i przeprowadzamy ręczną inspekcję w naszym centrum oceny, aby określić stan urządzenia. Wszystkie procedury oceny i przetwarzania danych są zgodne z Ogólnym rozporządzeniem o ochronie danych (RODO – UE 2016/679), co gwarantuje bezpieczeństwo i poufność Twoich informacji.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Co się stanie, jeśli stan urządzenia, który podałem, nie zgadza się z Waszą oceną?</div>
    <div class="text-box">
      <div class="text">
        Jeśli wystąpią różnice między stanem zadeklarowanym a oceną naszego zespołu, wyślemy Ci wiadomość e-mail zawierającą:<br>
        • <strong>Zaktualizowaną ofertę</strong> opartą na rzeczywistej inspekcji.<br>
        • <strong>Raport diagnostyczny</strong> i powody różnicy.<br><br>
        Możesz zaakceptować lub odrzucić ofertę:<br>
        • Jeśli zaakceptujesz, proces wymiany zostanie zakończony, a płatność trafi na Twoje konto bankowe w ciągu 3 dni roboczych.<br>
        • Jeśli odrzucisz, proces zwrotu zależy od Twojej lokalizacji:<br>
        &nbsp;&nbsp;• Dla klientów w Hiszpanii: przesyłka zwrotna zostanie zorganizowana bezpłatnie i pokryta przez Danghuan Europe S.L.<br>
        &nbsp;&nbsp;• Dla klientów spoza Hiszpanii: obowiązuje opłata za zwrot, maksymalnie 22 EUR / 19 GBP / 165 DKK / 245 SEK (z VAT).<br>
        &nbsp;&nbsp;• Opłatę należy uiścić w ciągu 5 dni kalendarzowych od otrzymania prośby o płatność, korzystając z oficjalnej, opłaconej etykiety zwrotnej dostarczonej przez Danghuan.<br>
        &nbsp;&nbsp;• Dane do płatności zostaną przekazane na żądanie lub zawarte w wiadomości e-mail z linkiem do płatności.<br>
        &nbsp;&nbsp;• Po potwierdzeniu płatności (jeśli dotyczy) Danghuan zweryfikuje transakcję w ciągu 5 dni roboczych i zorganizuje wysyłkę zwrotną na pierwotny adres. Otrzymasz wiadomość e-mail z potwierdzeniem wysyłki i numerem śledzenia przesyłki.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Co się stanie, jeśli nie odpowiem na zaktualizowaną ofertę?</div>
    <div class="text-box">
      <div class="text">
        Jeśli odpowiedź nie zostanie otrzymana w ciągu 30 dni kalendarzowych od daty powiadomienia, zaktualizowana oferta zostanie automatycznie uznana za odrzuconą.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Co dzieje się z moimi danymi osobowymi?</div>
    <div class="text-box">
      <div class="text">
        Musisz usunąć wszystkie dane przed wysłaniem urządzenia. Jeśli wykryjemy jakiekolwiek pozostałe dane, proces zostanie wstrzymany, a my skontaktujemy się z Tobą w celu ich usunięcia. W pełni przestrzegamy RODO (Rozporządzenie UE 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kto pokrywa koszty wysyłki?</div>
    <div class="text-box">
      <div class="text">
        Pierwsza przesyłka jest zawsze bezpłatna.<br><br>
        Jeśli odrzucisz zaktualizowaną ofertę:<br>
        • Dla klientów w Hiszpanii: przesyłka zwrotna zostanie zorganizowana bezpłatnie i pokryta przez Danghuan Europe S.L.<br>
        • Dla klientów spoza Hiszpanii: obowiązuje opłata za zwrot, maksymalnie 22 EUR / 19 GBP / 165 DKK / 245 SEK (z VAT).<br>
        • Opłatę należy uiścić w ciągu 5 dni kalendarzowych od otrzymania prośby o płatność, korzystając z oficjalnej, opłaconej etykiety zwrotnej dostarczonej przez Danghuan.<br>
        • Dane do płatności zostaną przekazane na żądanie lub zawarte w wiadomości e-mail z linkiem do płatności.<br>
        • Po potwierdzeniu płatności (jeśli dotyczy) Danghuan zweryfikuje transakcję w ciągu 5 dni roboczych i zorganizuje wysyłkę zwrotną na pierwotny adres. Otrzymasz powiadomienie e-mail, gdy paczka zostanie wysłana, wraz z informacjami o śledzeniu.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Co się stanie, jeśli moja paczka zaginie podczas transportu?</div>
    <div class="text-box">
      <div class="text">
        Jeśli Twoje urządzenie zaginie podczas transportu, Danghuan Europe S.L. pomoże Ci w przeprowadzeniu oficjalnej procedury reklamacyjnej z przewoźnikiem.<br><br>
        Przesyłka zostanie uznana za zagubioną, jeśli nie zostanie zarejestrowana, potwierdzona lub odebrana przez Danghuan w ciągu 15 dni kalendarzowych od przekazania jej kurierowi.<br><br>
        • Musisz użyć autoryzowanej, opłaconej etykiety wysyłkowej dostarczonej przez Danghuan; użycie innej metody anuluje ochronę w przypadku zaginięcia.<br>
        • Reklamacje do UPS należy zgłaszać w ciągu 60 dni od utworzenia etykiety.<br>
        • W przypadku przesyłek przez CORREOS (Hiszpania) reklamacje należy składać jak najszybciej, najlepiej w ciągu 15 dni, ale nie później niż w ciągu 1 roku od daty wysyłki.<br>
        • Danghuan pomoże w dochodzeniu prowadzonym przez przewoźnika, które zazwyczaj trwa 30–60 dni.<br><br>
        Jeśli zaginięcie zostanie potwierdzone w systemie logistycznym Danghuan, a użyto autoryzowanej etykiety, odszkodowanie nie przekroczy ostatecznej wartości urządzenia określonej w wycenie Trade-In.<br><br>
        Zatwierdzone płatności zostaną przelane bezpośrednio na numer IBAN podany podczas rejestracji.<br><br>
        <em>Uwaga: każde odszkodowanie zależy od polityki przewoźnika.</em>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kiedy otrzymam płatność?</div>
    <div class="text-box">
      <div class="text">
        Po zaakceptowaniu ostatecznej oferty płatność zostanie dokonana przelewem bankowym w ciągu 3 dni roboczych. Upewnij się, że Twój numer IBAN i numer identyfikacyjny są poprawne i zgodne z danymi właściciela konta.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Czy podanie mojego numeru identyfikacyjnego jest obowiązkowe?</div>
    <div class="text-box">
      <div class="text">
        Tak. Aby przetworzyć płatność, musisz podać ważny numer identyfikacyjny, bez spacji ani znaków specjalnych, który jest zgodny z właścicielem konta IBAN.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Czy mogę anulować swoją operację Trade-In?</div>
    <div class="text-box">
      <div class="text">
        Tak, jeśli Twoje stare urządzenie nie zostało jeszcze opłacone. Skontaktuj się z nami jak najszybciej pod adresem <a href="mailto:insta360@danghuan.eu">insta360@danghuan.eu</a>. Jeśli już wysłałeś urządzenie, skontaktuj się z nami w ciągu 48 godzin; w przeciwnym razie proces recyklingu będzie kontynuowany w normalnym trybie.
      </div>
    </div>
  </div>
`;